export enum EditWarningType {
  ChangesetUpdate = 'changesetupdate'
}
export interface EditWarning {
  type: EditWarningType;
  message: string;
  entityId: number;
}
